// ===========================================
// Countries React Query Hook
// ===========================================
// Fetches country data from API for address forms

import { useQuery } from '@tanstack/react-query';
import { countriesApi } from '../api/public.api';
import { Country } from '../constants/countries';

// ===========================================
// QUERY KEYS
// ===========================================

export const countriesKeys = {
  all: ['countries'] as const,
};

// ===========================================
// HOOKS
// ===========================================

/**
 * Fetch list of supported countries with states/provinces
 * Data is cached and rarely changes, so use long stale time
 */
export function useCountries() {
  return useQuery<Country[]>({
    queryKey: countriesKeys.all,
    queryFn: countriesApi.getAll,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours - country data rarely changes
    gcTime: 1000 * 60 * 60 * 24 * 7, // 7 days cache
  });
}

/**
 * Get a specific country by code from cached data
 */
export function useCountry(code: string) {
  const { data: countries, ...rest } = useCountries();
  const country = countries?.find((c) => c.code === code);
  return { data: country, ...rest };
}
